import { getStatementBatchCSV } from '../../billing/statement/statement-batches-csv-api-client';
import downloadCSV from '../../utils/download-csv';

export default async batchId => {
  const response = await getStatementBatchCSV(batchId);
  return downloadCSV(response);
};
